import { render, staticRenderFns } from "./IssueView.vue?vue&type=template&id=7ee968d9"
import script from "./IssueView.vue?vue&type=script&lang=ts"
export * from "./IssueView.vue?vue&type=script&lang=ts"
import style0 from "./IssueView.vue?vue&type=style&index=0&id=7ee968d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports